/**
 * Static Phoenix context marker (source_system / brand) used on non-event analytics
 * calls where super properties don't apply — identify traits, the Mixpanel People profile,
 * and the Mixpanel SDK's register() at init. `source_system: 'phoenix'` marks these calls
 * as originating from the Phoenix Customer Account app.
 */
export const PHOENIX_EVENT_CONTEXT = {
  source_system: 'phoenix',
  brand: 'lyka',
} as const

